import React, { useRef } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
    Button as MuiButton,
} from '@material-ui/core';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCloudUpload } from '@fortawesome/pro-solid-svg-icons';

type FileUploadButtonProps = {
    onFileSelect?: (files: FileList | null) => void,
    fileAccept?: string,
};

FileUploadButton.defaultProps = {
    onFileSelect: () => {},
    fileAccept: '*',
};

const useStyle = makeStyles((theme: Theme) => createStyles({
    root: {
        width: '100%',
        display: 'flex',
    },
    button: {
        width: '100%',
    },
}));

function FileUploadButton(props: FileUploadButtonProps): React.ReactElement {
    const {
        onFileSelect = FileUploadButton.defaultProps.onFileSelect,
        fileAccept,
    } = props;
    const classes = useStyle();
    const fileInputRef = useRef<HTMLInputElement>(null);

    function handleClick() {
        fileInputRef?.current?.click();
    }

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        onFileSelect(e.target.files);
    }

    return (
        <div className={classes.root}>
            <input
                type="file"
                onChange={handleChange}
                ref={fileInputRef}
                style={{ display: 'none' }}
                accept={fileAccept}
            />
            <MuiButton
                className={classes.button}
                color="primary"
                variant="outlined"
                size="large"
                onClick={handleClick}
            >
                上傳相關照片或資料
                <Icon icon={faCloudUpload} size="lg" style={{ marginLeft: 4 }} />
            </MuiButton>
        </div>
    );
}

export { FileUploadButton };
